import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/testimonials';
export function TestimonialsSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-20" data-id="element-308" data-mp="1mzsbo4cdzkgs">
      <div className="mx-auto max-w-5xl" data-id="element-309" data-mp="1r0ufkyh90kp3">
        <SectionHeading kicker="From the workbench" title={<>
              What technicians are <span className="text-electric-600" data-id="element-311" data-mp="1i0xv791w67zu">saying</span>
            </>} data-id="element-310" data-mp="1qzj92qwf4yua" />
        <ul className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-312" data-mp="14169em54vnba">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-canvas p-6" data-id="element-313" data-mp="182rtarg351uz">
              <div className="flex items-center gap-4" data-id="element-314" data-mp="184uij99eyqyn">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-white" loading="lazy" data-id="element-315" data-mp="2yg8tu5fbsf7c" />
                <div className="min-w-0" data-id="element-316" data-mp="2uzrjl4h3phln">
                  <p className="text-[17px] font-bold text-ink" data-id="element-317" data-mp="2q2raslsva0qu">{t.name}</p>
                  <p className="text-[14px] text-muted" data-id="element-318" data-mp="2q0naedu6fjvb">
                    {t.role} · {t.location}
                  </p>
                  <div className="mt-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-319" data-mp="2zskq9xw4r00d">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-320" data-mp="2c38eqrdbyfuw" data-mpi={i} />)}
                  </div>
                </div>
              </div>
              <blockquote className="mt-5 flex gap-3 text-[16px] leading-relaxed text-ink" data-id="element-321" data-mp="2m2h8pk873uh9">
                <QuoteIcon className="h-5 w-5 shrink-0 text-electric-500" aria-hidden="true" data-id="element-322" data-mp="2h10ajwh3im4d" />
                <p data-id="element-323" data-mp="19cc1wmfoljg">{t.quote}</p>
              </blockquote>
            </li>)}
        </ul>
        <CtaButton label="I want to work like them" className="mt-12" data-id="element-324" data-mp="3sg6pyv28lkhy" />
      </div>
    </section>;
}